import Icon from "./selfcare/Icon.tsx";
import {imageMap} from "../images/imageMap.ts";
import Cookies from "js-cookie";
import {useCallback, useEffect, useState} from "react";
import IconCross from "./icons/IconCross.tsx";

const ChatBotBoxCookieName = 'chatbot-hide'

export default function ChatBotBoxComponent(props: {showAfterScroll?: boolean}) {
    const [visible, setVisible] = useState<boolean>(false)

    const hasScrolled = useCallback(() => {
        if (window.scrollY >= 60) {
            setVisible(true)
        } else {
            setVisible(false)
        }
    }, [])

    const setHide = () => {
        setVisible(false)
        Cookies.set(ChatBotBoxCookieName, '1', {expires: 30});
    }

    const hasDisabledPopup = () => {
        const c = Cookies.get(ChatBotBoxCookieName)
        if (c === undefined) {
            return false
        }

        return c === '1'
    }

    useEffect(() => {
        if (hasDisabledPopup()) {
            return
        }

        if (props.showAfterScroll) {
            return
        }

        setVisible(true)
    }, [props.showAfterScroll])

    useEffect(() => {
        if (!props.showAfterScroll || hasDisabledPopup()) {
            return
        }

        window.addEventListener('scroll', hasScrolled);

        return () => window.removeEventListener('scroll', hasScrolled)
    }, [props.showAfterScroll, hasScrolled])

    if (!visible) {
        return
    }

    return (
        <div id={"chatbot-container"} className={'chatbot-show'}>
            <button className="close-chatbot-icon" aria-label="Luk chatbot dialogboks" onClick={() => setHide()}>
                <Icon component={IconCross}/>
            </button>
            <img
                className="chatbot hide-on-large-devices"
                src={imageMap.home.chatbot_tilted}
                alt="Har du brug for hjælp? Spørg vores chatbot Hibot."
            />
            <img
                className="chatbot hide-on-small-devices"
                src={imageMap.home.chatbot}
                alt="Har du brug for hjælp? Spørg vores chatbot Hibot."
            />
            <div className="chatbot-text">
                <p>
                    <span className="hide-on-large-devices">
                        <span className="small">Brug for hjælp?</span><br/>
                        <strong>Spørg HiBot</strong>
                    </span>
                    <span className="hide-on-small-devices">
                        <strong>
                            Spørg vores<br/>
                            chat-assistent,
                        </strong><br/>
                        eller chat med<br/>
                        en medarbejder
                    </span>
                </p>
            </div>
            <i className="hide-on-small-devices"></i>
        </div>
    )
}
